import React, { useState } from "react";
import profilePicture from "../assests/profilePicture.png";
import room from "../assests/room.png";
import lotus from "../assests/lotus.png";
import cert from "../assests/cert.png";
import { Envelope, GeoAlt, Telephone } from "react-bootstrap-icons";

export default function HomePage() {
  const [password, setPassword] = useState("");
  const [authorised, setAuthorised] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // change "mySecretPassword" to whatever you want
    if (password === "123") {
      setAuthorised(true);
      setError("");
    } else {
      setError("Incorrect password.");
    }
  };

  if (!authorised) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="card shadow-sm p-4">
          <h1 className="h5 mb-3 text-center">Enter password</h1>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <div className="alert alert-danger py-2 mb-3">
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary w-100">
              Continue
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="m-0 p-0">

      {/* Menu */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
        <div className="container">
          {/* <a className="navbar-brand fw-bold" href="#">
            Helen Watson Counselling
          </a> */}

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#pricing">Pricing</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <section className="py-5">
        <div className="text-center">
          <img src={lotus} alt="Lotus logo" height={45} className="" />
          <h1 className="fw-bold display-5 text-dark">
            Helen Watson Counselling
          </h1>
          <p className="text-secondary fs-5 mb-0">
            Supporting your emotional wellbeing with care and understanding.
          </p>
        </div>
      </section>

      <section id="about" className="py-5 section-beige-colour">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col text-center">
              <img
                src={profilePicture}
                alt="Helen Watson"
                className="img-fluid rounded-4 shadow-sm minWidth300"
                loading="lazy"
              />
            </div>

            <div className="col minWidth300">
              <h1 className="fw-bold mb-2 text-dark">About</h1>
              <h2 className="fw-bold mb-2 text-primary">Helen Watson</h2>
              <p className="text-muted">
                Carlisle Therapeutic Counsellor
              </p>
              <p>
                Diploma in Counselling 1998 to 2000 and BACP Member
              </p>
              <ul className="list-unstyled mb-4">
                <li>Level 2 Certificate in Counselling 1997 to 1998</li>
                <li>
                  Level 3 Diploma in Counselling (BACP Accredited) 1998 to 2000
                </li>
                <li>
                  Level 4 NVQ in Health and Social Care – Children and Young
                  People (City &amp; Guilds) 2008
                </li>
                <li>
                  I continually study and attend relevant training to improve my
                  practice.
                </li>
              </ul>
              <p className="mb-0 lh-lg">
                I am a qualified person centred counsellor with over 25 years of
                experience supporting individuals through a wide range of
                personal and emotional challenges. My work is grounded in
                empathy, authenticity and respect, creating a safe non
                judgmental space for exploration and growth. I have had the
                privilege of working successfully with many different people,
                helping them to develop greater self awareness, resilience, and
                confidence in themselves.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-md-6">
              <img
                src={room}
                alt="Counselling room"
                className="img-fluid rounded-4 shadow-sm w-100"
                loading="lazy"
              />
            </div>
            <div className="col-md-6">
              <h2 className="fw-bold mb-3 text-dark">Services</h2>
              <p className="fs5 lhlg mb0">
                I provide one to one counselling sessions for adults who are experiencing
                anxiety, grief, relationship difficulties, low self esteem, or major life
                changes. Sessions are available in person or online.
              </p>

              <p className="fs5 lhlg mb0">
                <strong>Person centered</strong> counselling focuses on creating a warm and supportive
                space where you can explore your thoughts and feelings at your own pace.
              </p>

              <p className="fs5 lhlg mb0">
                <strong>CBT</strong> helps you understand unhelpful thinking patterns and develop
                practical ways to manage them.
              </p>

              <p className="fs5 lhlg mb0">
                <strong>Couples</strong> and <strong>relation</strong> counselling supports partners in improving
                communication and resolving ongoing challenges.
              </p>

              <p className="fs5 lhlg mb0">
                <strong>General talking therapy</strong> allows you to speak openly about whatever is
                on your mind and receive guidance as you make sense of your experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="py-5 section-beige-colour">
        <div className="container">
          <h2 className="fw-bold mb-3 text-dark">Approach</h2>
          <p className="lh-lg mb-0">
            My approach is integrative and person centred, combining techniques
            from CBT, mindfulness, and humanistic therapy to meet your unique
            needs. I believe every individual has the capacity for growth, and
            my role is to help you rediscover that strength.
          </p>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <h1 className="fw-bold mb-2 text-dark">Pricing</h1>
          <h3 className="fw-bold mb-2 text-primary">
            Standard Rate £50 per hour
          </h3>
          <p className="text-secondary mb-1">
            This rate applies to a standard <strong>1 hour</strong> counselling
            session.
          </p>
          <p className="text-secondary mb-1">
            <strong>Reduced rates</strong> are available under certain
            circumstances.
          </p>
          {/* <p className="text-secondary">
            My aim is to make counselling as <strong>accessible</strong> as
            possible, so please feel free to discuss your situation if cost is a
            concern.
          </p> */}
        </div>
      </section>

      <section id="contact" className="py-5 section-beige-colour">
        <div className="container">
          <h1 className="fw-bold mb-3 text-dark">Contact</h1>

          <p className="text-secondary mb-2">
            To book a session or make an enquiry, please get in touch using the
            details below.
          </p>

          <p className="mb-1 d-flex align-items-center">
            <Telephone className="me-2 text-primary" size={20} /> 07496 427 530
          </p>

          <p className="mb-1 d-flex align-items-center">
            <Envelope className="me-2 text-primary" size={20} />{" "}
            helenwatsoncounselling@gmail.com
          </p>

          <p className="mb-1 d-flex align-items-center">
            <GeoAlt className="me-2 text-primary" size={20} />Carlisle, Cumbria, CA2
          </p>

          <p className="text-secondary">Full address available on request.</p>
        </div>
      </section>

      <footer className="py-5 bg-dark text-light">
        <div className="container">
          <div className="row text-center text-md-start">
            <div className="col-md-3 mb-3">
              <h5 className="fw-bold">Helen Watson Counselling</h5>
              <p className="mb-0">Supporting you towards a better tomorrow.</p>
            </div>

            <div className="col-md-3 mb-3">
              <h6 className="fw-bold">Site Map</h6>
              <ul className="list-unstyled">
                <li><a href="#" className="text-light text-decoration-none d-block mb-1 link-hover">Home</a></li>
                <li><a href="#" className="text-light text-decoration-none d-block mb-1 link-hover">About</a></li>
                <li><a href="#" className="text-light text-decoration-none d-block mb-1 link-hover">Pricing</a></li>
                <li><a href="#" className="text-light text-decoration-none d-block mb-1 link-hover">Contact</a></li>
              </ul>
            </div>

            {/* <div className="col-md-3 mb-3">
              <h6 className="fw-bold">Links</h6>
              <ul className="list-unstyled">
                <li><a href="https://www.counselling-directory.org.uk/counsellors/helen-watson-2" className="text-light text-decoration-none d-block mb-1 link-hover">BACP Profile</a></li>

              </ul>
            </div> */}

            <div className="col-md-3 mb-3">
              <h6 className="fw-bold">BACP Certified</h6>
              <p className="mb-2">Registered member of the British Association for Counselling and Psychotherapy.</p>
            </div>
          </div>

          <div className="text-center mt-4 small">
            &copy; {new Date().getFullYear()} Helen Watson Counselling. All rights reserved.
          </div>
        </div>
      </footer>

    </div>
  );
}
